import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Picture } from '@grandvisionhq/content';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/utils';
import '@grandvisionhq/common';
import '../../../utils/http-client.js';
import { parseBloomreachImage } from '../../../utils/parse-bloomreach-image.js';
import { generateConditionalClassNames } from '../utils/utils.js';

var CmsRowImage = ({ component  })=>{
    const _ref = component.getParameters(), { horizontalAlignment , verticalAlignment  } = _ref, cssStyles = swcHelpers.objectWithoutProperties(_ref, [
        "horizontalAlignment",
        "verticalAlignment"
    ]);
    const filteredStyles = Object.fromEntries(Object.entries(cssStyles).filter(([_, value])=>value !== ''
    ));
    const { image  } = component.getModels();
    const parsedImage = parseBloomreachImage(image);
    if (!image) return null;
    const rowImageClassName = generateConditionalClassNames('br-row-image', {
        horizontalAlignment,
        verticalAlignment
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: rowImageClassName,
        "data-t": "br-row-image",
        style: filteredStyles
    }, /*#__PURE__*/ React.createElement(Picture, {
        mobileUrl: parsedImage === null || parsedImage === void 0 ? void 0 : parsedImage.mobile.url,
        url: image.url,
        alt: parsedImage === null || parsedImage === void 0 ? void 0 : parsedImage.alt,
        height: image.original.height,
        width: image.original.width
    }));
};

export { CmsRowImage, CmsRowImage as default };
//# sourceMappingURL=RowImage.js.map
